/**
 * View states for the Slider Manager
 * These define the different states a view can be in during slide animations.
 *
 * Each state uses a descriptive CSS class name that makes it easy to understand
 * the view's role and position in the horizontal ribbon layout.
 */
const VIEW_SLIDING_STATE = {
  /**
   * The page currently visible in the viewport - this is the active reading page
   * CSS class: 'epub-slider-view-current-page'
   */
  CURRENT_PAGE: 'epub-slider-view-current-page',

  /**
   * A page preloaded ahead (to the right in LTR) - ready for next navigation
   * CSS class: 'epub-slider-view-preloaded-next'
   */
  PRELOADED_NEXT: 'epub-slider-view-preloaded-next',

  /**
   * A page preloaded behind (to the left in LTR) - ready for previous navigation
   * CSS class: 'epub-slider-view-preloaded-prev'
   */
  PRELOADED_PREV: 'epub-slider-view-preloaded-prev',
};

export default VIEW_SLIDING_STATE;
